import React, { useCallback } from 'react'

import { useRouter } from 'next/navigation'

import { SubsectionTitle } from 'Components/Blocks/Titles'
import { Button, Column } from 'Components/UI'

import { LANDING_CONTENT_PX } from 'Constants/Landing'

import { useResponsiveLayout } from 'Hooks'

import {
  EMAJIN_SECTION_QUESTION_ITEMS,
  EmajinSectionQuestionItem,
} from './constants'
import ImageContainer from './ImageContainer'
import { Container, Content } from './styles'

type Props = {
  onAction?: () => void
}

function EmajinSectionQuestions({ onAction }: Props) {
  const { isDesktop, isWideDesktop } = useResponsiveLayout()
  const router = useRouter()

  const handleClick = useCallback(
    (item: EmajinSectionQuestionItem) => {
      if (item.link) {
        router.push(item.link)
        return
      }

      onAction?.()
    },
    [onAction, router],
  )

  const isNotDesktop = !isWideDesktop && !isDesktop

  return (
    <Container
      gap={[0, 0, 64, 64, 80]}
      pb={[64, 64, 64, 64, 120]}
      pt={[0, 0, 64, 64, 120]}
    >
      {EMAJIN_SECTION_QUESTION_ITEMS.map((item, index) => (
        <Content
          flexDirection={[
            'column',
            'column',
            'column',
            'column',
            index % 2 === 0 ? 'row' : 'row-reverse',
          ]}
          gap={[0, 0, 32, 32, 64]}
          key={item.id}
          px={LANDING_CONTENT_PX}
        >
          <ImageContainer item={item} />

          <Column
            alignCenter={isNotDesktop}
            alignStart={!isNotDesktop}
            maxWidth={isNotDesktop ? 420 : 'unset'}
            width={[1, 1, 1, 1, 1 / 2]}
          >
            <SubsectionTitle
              centered={isNotDesktop}
              mb={[6, 6, 6, 6, 9]}
              paragraph={item.plainText}
              subtitle={item.subtitle}
              title={item.title}
            />

            <Button large onClick={() => handleClick(item)}>
              {item.buttonCaption}
            </Button>
          </Column>
        </Content>
      ))}
    </Container>
  )
}

export default EmajinSectionQuestions
